<script setup lang="ts">
import { useAddressBookProvider } from './useAddressBook.ts';
import AddressBook from './address-book.vue';

const { showModal, addressBook, save, simplify } = useAddressBookProvider();
</script>

<template>
  <teleport to="body">
    <AddressBook
      v-model:show-modal="showModal"
      v-model:address-book="addressBook"
      :simplify="simplify"
      @submit="save"
    />
  </teleport>
  <slot></slot>
  <div>

  </div>
</template>

<style scoped>

</style>
